import type * as React from 'react';
import styled from 'styled-components';

import { xdlColorSkeletonPrimary } from '@xing-com/tokens';

export const LANDSCAPE_SKELETON_ASPECT_RATIO = 16 / 9;
export const PORTRAIT_SKELETON_ASPECT_RATIO =
  1 / LANDSCAPE_SKELETON_ASPECT_RATIO;

export type PlayerSkeletonProps = { isStory?: boolean };

export const PlayerSkeleton: React.VFC<PlayerSkeletonProps> = ({ isStory }) => {
  const aspectRatio = isStory
    ? PORTRAIT_SKELETON_ASPECT_RATIO
    : LANDSCAPE_SKELETON_ASPECT_RATIO;

  return (
    <Container $aspectRatio={aspectRatio} data-qa="video-player-skeleton" />
  );
};

const Container = styled.div<{ $aspectRatio: number }>`
  background-color: ${xdlColorSkeletonPrimary};
  width: 100%;
  padding-top: ${({ $aspectRatio }) => `${(1 / $aspectRatio) * 100}%`};
`;
